import { RouteRecordRaw } from 'vue-router';
import DocumentLayout from '@/layouts/DocumentLayout.vue';

export default [
  {
    path: '/refund-policy',
    component: DocumentLayout,
    children: [
      {
        path: '',
        name: 'RefundPolicy',
        component: () =>
          import(
            /* webpackChunkName: "refund-policy" */ '@/views/documents/RefundPolicy.vue'
          ),
        meta: {
          title: 'Refund policy',
        },
      },
    ],
  },
  {
    path: '/terms-of-use',
    component: DocumentLayout,
    children: [
      {
        path: '',
        name: 'TermsOfUse',
        component: () =>
          import(
            /* webpackChunkName: "terms-of-use" */ '@/views/documents/TermsOfUse.vue'
          ),
        meta: {
          title: 'Terms of use',
        },
      },
    ],
  },
  {
    path: '/web-terms-of-use',
    component: DocumentLayout,
    children: [
      {
        path: '',
        name: 'TermsOfUseWeb',
        component: () =>
          import(
            /* webpackChunkName: "terms-of-use-web" */ '@/views/documents/TermsOfUseWeb.vue'
          ),
        meta: {
          title: 'Terms of use',
        },
      },
    ],
  },
  {
    path: '/license-agreement',
    component: DocumentLayout,
    children: [
      {
        path: '',
        name: 'LicenseAgreement',
        component: () =>
          import(
            /* webpackChunkName: "license-agreement" */ '@/views/documents/LicenseAgreement.vue'
          ),
        meta: {
          title: 'License Agreement',
        },
      },
    ],
  },
  {
    path: '/android-terms-of-use',
    component: DocumentLayout,
    children: [
      {
        path: '',
        name: 'TermsOfUseAndroid',
        component: () =>
          import(
            /* webpackChunkName: "terms-of-use-android" */ '@/views/documents/TermsOfUseAndroid.vue'
          ),
        meta: {
          title: 'Terms of use',
        },
      },
    ],
  },
  {
    path: '/ios-terms-of-use',
    component: DocumentLayout,
    children: [
      {
        path: '',
        name: 'TermsOfUseIos',
        component: () =>
          import(
            /* webpackChunkName: "terms-of-use-ios" */ '@/views/documents/TermsOfUseIos.vue'
          ),
        meta: {
          title: 'Terms of use',
        },
      },
    ],
  },
  {
    path: '/web-privacy-policy',
    component: DocumentLayout,
    children: [
      {
        path: '',
        name: 'PrivacyPolicyWeb',
        component: () =>
          import(
            /* webpackChunkName: "web-privacy-policy" */ '@/views/documents/PrivacyPolicyWeb.vue'
          ),
        meta: {
          title: 'Privacy policy',
        },
      },
    ],
  },
  {
    path: '/privacy-policy',
    component: DocumentLayout,
    children: [
      {
        path: '',
        name: 'PrivacyPolicy',
        component: () =>
          import(
            /* webpackChunkName: "privacy-policy" */ '@/views/documents/PrivacyPolicy.vue'
          ),
        meta: {
          title: 'Privacy policy',
        },
      },
    ],
  },
  {
    path: '/android-privacy-policy',
    component: DocumentLayout,
    children: [
      {
        path: '',
        name: 'PravicyPolicyAndroid',
        component: () =>
          import(
            /* webpackChunkName: "privacy-policy-android" */ '@/views/documents/PravicyPolicyAndroid.vue'
          ),
        meta: {
          title: 'Privacy policy',
        },
      },
    ],
  },
  {
    path: '/ios-privacy-policy',
    component: DocumentLayout,
    children: [
      {
        path: '',
        name: 'PravicyPolicyIos',
        component: () =>
          import(
            /* webpackChunkName: "privacy-policy-ios" */ '@/views/documents/PravicyPolicyIos.vue'
          ),
        meta: {
          title: 'Privacy policy',
        },
      },
    ],
  },
] as RouteRecordRaw[];
